import { Product } from "features/ProductReel/types";
import SampleProductCard from "features/cart/SampleProductCard";
import React from "react";
import styled from "styled-components";
import { DefaultText } from "theme/GlobalElements";

interface SearchResultProps {
  result: any;
  viewAll: (event: any) => void;
}

const SearchResult: React.FC<SearchResultProps> = ({ result, viewAll }) => {
  return result.length !== 0 ? (
    <>
      {result.map((product: Product, idx: number) => {
        return <SampleProductCard key={idx} item={{ product }} />;
      })}
      <DefaultText
        style={{ padding: "10px", textAlign: "center", cursor: "pointer" }}
        fontSize={12}
        onClick={viewAll}
      >
        виж всички
      </DefaultText>
    </>
  ) : (
    <DefaultText style={{ padding: "10px" }} fontSize={12}>
      Няма резултат по зададения критерии.
    </DefaultText>
  );
};

const SearchResultContainer = styled.div``;

export default SearchResult;
